var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { attachKey2click } from "../../reactSurvey";
import { ReactSurveyElement } from "../../reactquestion_element";
import { SvgIcon } from "../svg-icon/svg-icon";
import { ReactElementFactory } from "../../element-factory";
var SurveyFileChooseButton = /** @class */ (function (_super) {
    __extends(SurveyFileChooseButton, _super);
    function SurveyFileChooseButton(props) {
        return _super.call(this, props) || this;
    }
    Object.defineProperty(SurveyFileChooseButton.prototype, "question", {
        get: function () {
            return (this.props.item && this.props.item.data.question) || this.props.data.question;
        },
        enumerable: false,
        configurable: true
    });
    SurveyFileChooseButton.prototype.render = function () {
        var _this = this;
        return attachKey2click(React.createElement("label", { tabIndex: 0, className: this.question.getChooseFileCss(), htmlFor: this.question.inputId, "aria-label": this.question.chooseButtonText, onClick: function (e) { return _this.question.chooseFile(e.nativeEvent); } },
            (!!this.question.cssClasses.chooseFileIconId) ? React.createElement(SvgIcon, { title: this.question.chooseButtonText, iconName: this.question.cssClasses.chooseFileIconId, size: "auto" }) : null,
            React.createElement("span", null, this.question.chooseButtonText)));
    };
    return SurveyFileChooseButton;
}(ReactSurveyElement));
export { SurveyFileChooseButton };
ReactElementFactory.Instance.registerElement("sv-file-choose-btn", function (props) {
    return React.createElement(SurveyFileChooseButton, props);
});
